import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { KnowledgeBotModel } from '../models/knowledge_bot_model';

angular
  .module('capability-ng-priority-feed')
  .factory(
    'loadKBNameCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      getJwtTokenCommand: ICommand,
      ngKnowledgeBotModel: KnowledgeBotModel
    ): ICommand => {
      return defineCommandORM('loadKBNameCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
        getJwtTokenCommand()
          .then((token: any) => {
            $http.get('core/retrieve_endpoint/?service_key=navai&endpoint_name=products').then((response: any) => {
              const config = {
                url: response.data.access_url + '/1',
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${token.access_token}`
                }
              };
              $http(config).then(({ data }: any) => {
                ngKnowledgeBotModel.write({ name: data.name });
                deferred.resolve();
              });
            });
          })
          .catch((e: any) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/load_kb_name_command.ts